import React from 'react';
import { CheckIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { services } from '../data/services';
import { SectionHeading } from './SectionHeading';
export function Services() {
  const {
    t
  } = useLanguage();
  const featured = services.find(service => service.featured);
  const rest = services.filter(service => !service.featured);
  return <section id="services" className="bg-mist" data-id="element-320" data-mp="13xxy9dwnufpm">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-321" data-mp="z4wcqn1y7hx2">
        <SectionHeading kicker={t(copy.servicesKicker)} title={t(copy.servicesTitle)} subtitle={t(copy.servicesSubtitle)} data-id="element-322" data-mp="u5s5i1yl3u9d" />

        {featured ? <div className="mt-12 overflow-hidden rounded-3xl bg-royal shadow-lift" data-id="element-323" data-mp="l5di8x228538">
            <div className="grid gap-8 p-7 sm:p-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14" data-id="element-324" data-mp="l7ga7mmrw8al">
              <div data-id="element-325" data-mp="g726ggs7fkid">
                <div className="flex items-center gap-3" data-id="element-326" data-mp="36chjg6cktfym">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/15" data-id="element-327" data-mp="36awoifmcnv08">
                    <featured.icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-328" data-mp="3b4r354n3ljsg" />
                  </span>
                  <span className="rounded-full bg-aqua px-3 py-1 font-display text-xs font-bold text-navy" data-id="element-329" data-mp="2xdmc2qxspztq">
                    {t(copy.popular)}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-330" data-mp="3q18f9y3432g2">
                  {t(featured.title)}
                </h3>
                <p className="mt-3 max-w-lg text-base leading-relaxed text-white/80" data-id="element-331" data-mp="3g17u06lomc98">
                  {t(featured.description)}
                </p>
                {featured.duration ? <p className="mt-6 flex items-center gap-2 text-sm text-white/70" data-id="element-332" data-mp="24muim1847pa3">
                    <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-333" data-mp="29mqdnayu46di" />
                    {t(featured.duration)}
                  </p> : null}
                <a href="#contact" className="mt-8 inline-flex items-center gap-2 rounded-xl bg-bright px-6 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-white hover:text-royal" data-id="element-334" data-mp="1pm6wfdybuunt">
                  {t(copy.bookNow)}
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-335" data-mp="16tl3b1et1i6x" />
                </a>
              </div>

              <div className="rounded-2xl bg-white/10 p-6" data-id="element-336" data-mp="11u08922r9tzh">
                <p className="font-display text-xs font-bold uppercase tracking-[0.14em] text-aqua" data-id="element-337" data-mp="11wmft1pnc9hp">
                  {t(copy.includes)}
                </p>
                <ul className="mt-4 space-y-3" data-id="element-338" data-mp="suv7rq7mvqko">
                  {featured.features.map(feature => <li key={feature.en} className="flex items-start gap-3 text-white/90" data-id="element-339" data-mp="2s5mmoyezn966">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-340" data-mp="2n8w8yhqnopnx" />
                      <span className="text-sm" data-id="element-341" data-mp="2uqcaisctby3e">{t(feature)}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div> : null}

        <ul className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-342" data-mp="34i87u172rk6k">
          {rest.map(service => <li key={service.id} className="flex flex-col rounded-2xl border border-navy/10 bg-white p-6 shadow-card transition-shadow duration-200 ease-out hover:shadow-lift" data-id="element-343" data-mp="39fqflo9cvtcz">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-bright/10" data-id="element-344" data-mp="2gtp1vsbhzjhn">
                <service.icon className="h-5 w-5 text-royal" aria-hidden="true" data-id="element-345" data-mp="2lt1wx0civwvb" />
              </span>
              <h3 className="mt-5 font-display text-lg font-extrabold text-navy" data-id="element-346" data-mp="2ppxzd1fx0815">
                {t(service.title)}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-charcoal/70" data-id="element-347" data-mp="51a8tul8n584">
                {t(service.description)}
              </p>
              <ul className="mt-5 space-y-2 border-t border-navy/10 pt-5" data-id="element-348" data-mp="3leiie6g54jf">
                {service.features.map(feature => <li key={feature.en} className="flex items-start gap-2" data-id="element-349" data-mp="3utjyn801r36x">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-bright" aria-hidden="true" data-id="element-350" data-mp="dkdlph8g07z1" />
                    <span className="text-sm text-charcoal/80" data-id="element-351" data-mp="8io75rm0hc67">{t(feature)}</span>
                  </li>)}
              </ul>
              <div className="mt-auto pt-6" data-id="element-352" data-mp="hkxde5a8yjds">
                {service.duration ? <p className="flex items-center gap-2 text-xs font-medium text-charcoal/60" data-id="element-353" data-mp="w9k4t5d5f1ld">
                    <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-354" data-mp="rah05m12yxdx" />
                    {t(service.duration)}
                  </p> : null}
                <a href="#contact" className="mt-3 flex items-center justify-center gap-2 rounded-xl border border-royal px-5 py-3 font-display text-sm font-bold text-royal transition-colors duration-150 ease-out hover:bg-royal hover:text-white" data-id="element-355" data-mp="15arpulqnm5xi">
                  {service.ctaKey === 'book' ? t(copy.bookNow) : t(copy.viewAllServices)}
                </a>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}